import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Clock, Calendar, User } from "lucide-react";
import { api } from "../lib/api";
import CTASection from "../components/CTASection";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="py-32 text-center text-slate-500">Cargando...</div>;
  }
  if (!post) {
    return (
      <div className="py-32 text-center">
        <h1 className="text-3xl font-bold text-slate-900 mb-4">Artículo no encontrado</h1>
        <Link to="/blog" className="btn-primary">Volver al blog</Link>
      </div>
    );
  }

  const paragraphs = post.content.split("\n\n");

  return (
    <div data-testid="blog-post-page">
      <section className="py-12 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max max-w-3xl">
          <Link to="/blog" data-testid="back-to-blog" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-teal-700 mb-8">
            <ArrowLeft className="w-4 h-4" /> Volver al blog
          </Link>
          <span className="inline-block px-3 py-1 rounded-full bg-teal-50 text-teal-700 text-xs font-semibold mb-4">
            {post.category}
          </span>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6 leading-tight">
            {post.title}
          </h1>
          <div className="flex flex-wrap gap-4 text-sm text-slate-500">
            <span className="flex items-center gap-1.5"><User className="w-4 h-4" /> {post.author}</span>
            <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4" /> {post.published_at}</span>
            <span className="flex items-center gap-1.5"><Clock className="w-4 h-4" /> {post.read_time} min de lectura</span>
          </div>
        </div>
      </section>

      <section className="py-10">
        <div className="container-max max-w-3xl">
          <img src={post.image} alt={post.title} className="w-full h-96 object-cover rounded-3xl mb-12" />
          <div className="prose-article">
            {paragraphs.map((p, i) => {
              if (p.startsWith("## ")) {
                return <h2 key={i}>{p.replace("## ", "")}</h2>;
              }
              if (p.startsWith("- ")) {
                const items = p.split("\n").map((l) => l.replace(/^- /, ""));
                return (
                  <ul key={i}>
                    {items.map((it, j) => (
                      <li key={j} dangerouslySetInnerHTML={{ __html: it.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
                    ))}
                  </ul>
                );
              }
              if (/^\d+\./.test(p)) {
                const items = p.split("\n").map((l) => l.replace(/^\d+\.\s*/, ""));
                return (
                  <ol key={i}>
                    {items.map((it, j) => (
                      <li key={j} dangerouslySetInnerHTML={{ __html: it.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
                    ))}
                  </ol>
                );
              }
              return (
                <p key={i} dangerouslySetInnerHTML={{ __html: p.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
              );
            })}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
